export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";